import { FC, useEffect, useState } from 'react'
import CustomizedInput from '../../CreateForm/InputBase';
import CustomizedSingleSelectDropdown from '../../CreateForm/DropdownBase';
import { logicalOperations } from '../../../Utils/common';

interface ConditionalInputProps {
    onChange: (e: any) => void;
    value: { key: string, value: any | undefined } | undefined
}

const ConditionalInput: FC<ConditionalInputProps> = ({ onChange, value }) => {
    const [logicalState, setLogicalState] = useState<string>('less_than');
    const [dateValue, setDateValue] = useState<string>('0')

    const handleChange = (inputVal: string, updateVal?: string) => {
        const inputValueAsNumber = parseInt(inputVal, 10);
        const newUpdateVal = updateVal ? updateVal : logicalState
        let newDateValue = '0';

        if (newUpdateVal === 'greater_than') {
            onChange({ 'key': ">", "value": inputVal });
            newDateValue = inputValueAsNumber.toString();
        } else if (newUpdateVal === 'less_than') {
            onChange({ 'key': "<", "value": inputVal });
            newDateValue = `${inputValueAsNumber}`;
        } else {
            onChange({ 'key': "=" });
        }
        // Update dateValue directly
        setDateValue(newDateValue);
    };

    useEffect(() => {
        setDateValue(value?.value ?? 0);
        setLogicalState(logicalOperations.filter((operator) => operator?.label === value?.key)?.[0]?.value ?? logicalState)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className='conditional_logic'>
            <CustomizedSingleSelectDropdown
                value={logicalState}
                dataProvider={logicalOperations}
                setValue={(e: string) => {
                    setLogicalState(e);
                    handleChange(dateValue, e)
                }}
            /> {logicalState !== "equal_to" && <CustomizedInput
                className='customized_input'
                required={false}
                value={dateValue}
                onChange={(e: any) => handleChange(e.target.value)}
                type="number"
            />}
            <span>{['less_than', 'greater_than'].includes(logicalState) ? `days from ` : ""}Today</span>
        </div>


    )
}

export default ConditionalInput